import React from 'react';
import {
  AlertOutlined,
  DesktopOutlined,
  HddOutlined,
  BranchesOutlined,
  RobotOutlined,
  FundOutlined,
} from '@ant-design/icons';
import { ROUTES } from './routes';

/**
 * Navigation menu configuration
 * Defines the main navigation structure with routes, icons, and identifiers
 * @constant {Object}
 */
export const navigationMenus = {
  navigation: [
    {
      key: '1',
      icon: <AlertOutlined />,
      label: 'Alerts',
      path: ROUTES.ALERTS,
      identifer: 1,
    },
    {
      key: '2',
      icon: <DesktopOutlined />,
      label: 'Admin',
      path: ROUTES.ADMIN,
      identifer: 9,
    },
    {
      key: '3',
      icon: <HddOutlined />,
      label: 'Resource',
      path: ROUTES.RESOURCE,
      identifer: 10,
    },
    {
      key: '5',
      icon: <BranchesOutlined />,
      label: 'Releases',
      path: ROUTES.RELEASE_MANAGEMENT,
      identifer: 16,
      children: [
        {
          key: '10',
          label: 'Support',
          path: ROUTES.RELEASE_SUPPORT,
          identifer: 92,
        },
        {
          key: '6',
          label: 'Dashboard',
          path: ROUTES.RELEASE_DASHBOARD,
          identifer: 18,
        },
        {
          key: '7',
          label: 'Calendar',
          path: ROUTES.RELEASE_CALENDAR,
          identifer: 19,
        },
        {
          key: '8',
          label: 'List',
          path: ROUTES.RELEASE_LIST,
          identifer: 20,
        },
        {
          key: '9',
          label: 'Test Cases',
          path: ROUTES.RELEASE_TEST_CASES,
          identifer: 59,
        },
        {
          key: '12',
          label: 'Pivot Report',
          path: ROUTES.RELEASE_PIVOT_REPORT,
          identifer: 159,
        },
      ],
    },
    {
      key: '13',
      icon: <RobotOutlined />,
      label: 'Agents',
      path: ROUTES.AGENTS,
      identifer: 160,
      children: [
        {
          key: '161',
          label: 'Release Analyzer',
          path: ROUTES.RELEASE_ANALYZER,
          identifer: 161,
        },
        {
          key: '162',
          label: 'File Comparison',
          path: ROUTES.FILE_COMPARE,
          identifer: 162,
        },
        {
          key: '194',
          label: 'Knowledge Base',
          path: ROUTES.KNOWLEDGE_BASE,
          identifer: 194,
        },
        {
          key: '193',
          label: 'Test Case Creator',
          path: ROUTES.TEST_CASE_CREATOR,
          identifer: 193,
        },
      ],
    },
    {
      key: '191',
      icon: <FundOutlined />,
      label: 'Reports',
      path: ROUTES.REPORTS,
      identifer: 191,
      children: [
        {
          key: '192',
          label: 'Release QA Dashboard',
          path: ROUTES.RELEASE_QA_DASHBOARD,
          identifer: 192,
        },
        {
          key: '195',
          label: 'Regression Dashboard',
          path: ROUTES.REGRESSION_DASHBOARD,
          identifer: 195,
        },
      ],
    },
  ],
};
